export default "__VITE_ASSET__eede9aa6__"